import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddSpecificationWizard.scss';
import {
  __,
  getActiveProject,
  getActiveStage,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import autobind from 'autobind-decorator';
import { setNotification } from '../redux/actions/general/notification';
import { readProjectGeneral } from '../redux/actions/projects';
import {
  copySpecification,
  listWorkingSetSpecifications,
} from '../redux/actions/table/working_set_specifications';
import CopySpecificationIcon from '../assets/images/specification-copy-64x64.svg';
import CreateOptionForm from '../forms/create_option_wizard/CreateOptionForm';
import * as _ from 'lodash';

@subscribe(Localization, 'localization')
@mapStateToProps((state) => ({
  source_specification:
    state.table.working_set_specifications.create_option_source_specification ||
    {},
}))
class CreateOptionWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      project_language: null,
    };
  }

  componentDidMount() {
    readProjectGeneral(getActiveProject()).then(({ response }) => {
      this.setState({ project_language: response.data.main_language });
    });
  }

  @autobind
  _handleCreateOption(formData) {
    const { edit } = formData;
    const { source_specification } = this.props;

    const copy_payload = {
      project_id: source_specification.project_id,
      stage_id: source_specification.stage_id,
      team_id: source_specification.team_id,
      specification_subgroup_id: source_specification.specification_subgroup_id,
      code: _.padStart(_.toString(source_specification.code), 2, '0'),
      action: formData.action,
      description: formData.description,
    };

    return validateForm(
      copySpecification(source_specification.id, copy_payload).then(
        ({ response }) => {
          const specification_id = response.data.id;
          this.props.onClose();

          listWorkingSetSpecifications(getActiveStage());

          setNotification(
            __(
              'specifications.copy-specification.successfully-copied-specification'
            )
          );

          if (edit) {
            setTableParams('working_set_specifications', {
              clicked_row: specification_id,
            });
          }
        }
      )
    );
  }

  render() {
    const { project_language } = this.state;
    const { source_specification } = this.props;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {__(
                'specifications.working-set.create-option-wizard.title',
                {},
                'Create option'
              )}
            </span>
            <span>
              {__(
                'specifications.working-set.create-option-wizard.description',
                {},
                'Create a new option with the same specification code.'
              )}
            </span>
          </div>
          <div className={styles.right}>
            <CopySpecificationIcon />
          </div>
        </div>
        <div className={styles.body}>
          <CreateOptionForm
            onSubmit={this._handleCreateOption}
            projectLanguage={project_language}
            initialValues={{
              action: 'option_alternative',
              description: source_specification.description || {},
            }}
          />
        </div>
      </>
    );
  }
}

export default CreateOptionWizard;
